import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { IntercompanyBranchContainerModel } from '../../../../../models/aggregates/intercompany/index';

@Injectable({ providedIn: 'root' })
export class EntityBranchHdrLoginEntityService extends BaseApiTemplateService<IntercompanyBranchContainerModel> {
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-branch-hdrs/login-entity-ep';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-branch-hdrs/login-entity-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-branch-hdrs/login-entity-ep';
        this.httpClient = http;
    }
}
